import { createMemo, For, Match, Show, Switch } from "solid-js";
import type { ExhibitionCardProps } from "../_model";
import { solidstate } from ":setup/qstate";
import { global } from ":shared/app";

const tabs = ["file", "info"] as const;
export function ExploreProject(props: ExhibitionCardProps) {
  const $active_tab = solidstate.create<(typeof tabs)[number]>(tabs[0]);
  const $breakpoint = global.store.hooks.dom.useBreakpoints();

  function Info(props: { title: string; value: string }) {
    return (
      <p class="flex flex-col gap-1">
        <span class="text-1.3em font-600 rounded-md font-bold">{props.title}</span>
        <span class="font-400  rounded-md">{props.value}</span>
      </p>
    );
  }
  function TeamMembers() {
    return (
      <div class=" flex flex-col gap-1">
        <h2 class="font-400 rounded-md font-bold text-1.3em">Team Members</h2>
        <For each={props?.team_members}>
          {(member) => {
            return (
              <div class="flex justify-start gap-1 items-center ">
                <div class={`w-10px h-10px rounded-full bg-brand }`} />
                <p class={`w-full text-14px py-1  text-start text-black `}>{member?.name ?? "No name"}</p>
              </div>
            );
          }}
        </For>
      </div>
    );
  }
  function File() {
    return (
      <div class="flex w-full h-full">
        <Show
          when={props?.project_images != undefined}
          fallback={
            <div class="w-full text-black flex justify-center items-center font-bold text-xl">No PDF Provided</div>
          }
        >
          <iframe src={props?.project_images} class="w-full h-full" />
        </Show>
      </div>
    );
  }
  return (
    <Switch>
      <Match when={$breakpoint()?.misc?.lg.widthIsLess}>
        <section class="grid grid-cols-2 w-full h-40px gap-2 text-20px capitalize">
          <For each={tabs}>
            {(tab) => {
              const $active = createMemo(() => {
                return $active_tab.value === tab;
              });
              return (
                <span
                  class={
                    //
                    "flex w-full h-full border-b-2 border-solid text-center text-center self-center items-center justify-center" +
                    " " +
                    ($active() ? "text-brand border-brand" : "text-text-alt border-bg-alt")
                  }
                  onclick={() => {
                    const value = $active_tab.value;
                    if (value !== tab) {
                      $active_tab.set(tab);
                    }
                  }}
                >
                  {tab}
                </span>
              );
            }}
          </For>
        </section>
        <Switch>
          <Match when={$active_tab.value === "file"}>
            <div class="w-full h-full py-1 overflow-hidden">
              <File />
            </div>
          </Match>
          <Match when={true}>
            <div class="flex flex-col w-full h-full text-16px !overflow-auto px-2 pt-2 gap-2">
              {/* <h2 class="bg-bg-button text-text-button font-bold text-16px rounded-md px-2 py-2 ">Team</h2> */}
              <Info title="Team Name" value={props.team_name ?? "No team name"} />
              <Info title="Track" value={props.track ?? "No track"} />
              <Info title="Project Name" value={props.project_name ?? "No project name"} />
              <Info title="Project Ideation" value={props.ideation ?? "No Project Ideation"} />

              <TeamMembers />
            </div>
          </Match>
        </Switch>
      </Match>
      <Match when={true}>
        <section class="grid grid-cols-[1fr_0.3fr] w-full h-full gap-2 px-1 py-1 overflow-hidden">
          <File />
          <div class="flex flex-col w-full h-full text-16px !overflow-auto px-2 pt-2 gap-2">
            {/* <h2 class="bg-bg-button text-text-button font-bold text-16px rounded-md px-2 py-2 ">Team</h2> */}
            <Info title="Team Name" value={props.team_name ?? "No team name"} />
            <Info title="Track" value={props.track ?? "No track"} />
            <Info title="Project Name" value={props.project_name ?? "No project name"} />
            <Info title="Project Ideation" value={props.ideation ?? "No Project Ideation"} />

            <TeamMembers />
          </div>
        </section>
      </Match>
    </Switch>
  );
}
